


export const colorTargetReplacement = (colorTarget) => {
  const map = {
    "EXTERIOR_COLOR_PRIMARY" : "EXT_MAIN",
    "EXTERIOR_COLOR_SECONDARY" : "EXT_SPECIAL",
    "EXTERIOR_PINSTRIPE" : "EXT_PINSTRIPE",
    "INTERIOR_KEY_COLOR" : "INT_KEY",
    "INTERIOR_SECONDARY_COLOR" : "INT_SECONDARY",
    "INTERIOR_THIRD_COLOR" : "INT_THIRD",
  }


  if(colorTarget !== undefined && colorTarget !== null && colorTarget.trim() !== "") {
    let keyCode = map[colorTarget];
    if(keyCode) {
      return keyCode;
    } else if(!keyCode) {
      return "INT_" + colorTarget;
    }
  }
}




export const stepMgmtDataProcessing = (productStepManagementData, langData, paramsId) => {
  let allColorItems = [];
  let navForHeader = [];


  const processedNavData = productStepManagementData.sort((a, b) => a.navOrder - b.navOrder).map((navData) => {
    const newNavStepsArray = []
    // const stepGroupArray = [];


    navData.navigationSteps.sort((a, b) => a.stepOrder - b.stepOrder).map((navStepData) => {

      let childNavList = productStepManagementData.filter(item => item.childButtonPosition === navStepData.id);

      const newNavStepData = { //새로 정립된 각각의 스텝데이터
        childNavData: childNavList,
        id: navStepData.id,
        nameEn: navStepData.nameEn,
        nameKr: navStepData.nameKr,
        stepItems: navStepData.stepItems.filter(i => i.active).sort((a, b) => a.itemOrder - b.itemOrder),
        stepType: navStepData.stepType,
        active: navStepData.active,
        cameraType: navStepData.cameraType,
        cameraCode: navStepData.cameraCode,
      }

      if (navStepData.stepType !== "COLOR" && navStepData.stepType !== "COLORWAY") {
        newNavStepData.stepTabs = navStepData.tabs
      }

      // const stepOrder = navStep.stepOrder -1;
      const firstStepItemData = navStepData.stepItems[0] && navStepData.stepItems[0];

      if (firstStepItemData && navStepData.active) {
        if (navStepData.stepType === "COLOR") {
          allColorItems = [...allColorItems, ...navStepData.stepItems];
        }

        if (navStepData.stepType === "PART_2D" && !firstStepItemData.partPersonalization) {
          return;
        }

        newNavStepsArray.push(newNavStepData);
      }
    });


    let parentNavigationData = null;
    if (navData.parentId) {
      parentNavigationData = productStepManagementData.find(item => item.id === navData.parentId);
    }


    const newNavData = {
      id: navData.id,
      nameEn: navData.nameEn,
      nameKr: navData.nameKr,
      navOrder: navData.navOrder,
      navigationSteps: newNavStepsArray,
      isGnb: navData.isGnb,
      linkPath: navData.parentId ? parentNavigationData?.linkPath.toLowerCase() : navData.linkPath.toLowerCase(),
      cameraType: navData.cameraType,
      cameraCode: navData.cameraCode,
      parentId: navData.parentId,
      childNavigationIdList: navData.childNavigationIdList || null,
      childButtonPosition: navData.childButtonPosition
    };

    return newNavData;
  });

  const setNavForHeader = () => processedNavData.filter(item => !item.parentId).map((menu) => {
    const item = {};
    let path = menu["linkPath"] && menu["linkPath"].toLowerCase();
    if (!menu.isGnb) {
      path = `/${langData.lang}/${paramsId.toLowerCase()}/configurator/${path}`;
    } else if (menu.isGnb) {
      if (path[0] && path[0] !== "/") {
        path = "/" + path;
      }
      path = `/${langData.lang}/${paramsId.toLowerCase()}${path}`;
    } else {
      path = path;
    }
    item.id = menu["linkPath"] && menu["linkPath"].toLowerCase();
    item.title = menu[langData.langName];
    item.gnb = menu.isGnb;
    item.cameraCode = menu.cameraCode;
    item.cameraType = menu.cameraType;
    item.path = path;

    return item;
  });

  navForHeader = setNavForHeader();


  return { processedNavData, allColorItems, navForHeader }
}
